import { useEffect, useState } from "react";

import useCustomSelector from "../../../redux/hooks/useCustomSelector";
import useActionCreator from "../../../redux/hooks/useActionCreator";

import { SoftwareInventoryState } from "@reducers/types/inventory/software-inventory";

import { SoftwareInventoryType } from "@type/inventory/software-inventory";

interface UseSoftwareInventoryById {
  softwareInventoryState: SoftwareInventoryState;
  createSoftwareInventory: (
    id: string | number,
    data: SoftwareInventoryType,
  ) => void;
}

export const useSoftwareInventoryById = (
  id: string | number,
): UseSoftwareInventoryById => {
  const { fetchSoftwareInventory, updateSoftwareInventory } =
    useActionCreator();

  const softwareInventoryState = useCustomSelector(
    (store) => store.inventory.softwareInventoryState,
  );

  const createSoftwareInventory = (
    id: string | number,
    data: SoftwareInventoryType,
  ) => {
    updateSoftwareInventory(id, data);
  };

  useEffect(() => {
    if (id) {
      fetchSoftwareInventory(id);
    }
  }, [id]);

  return {
    softwareInventoryState,
    createSoftwareInventory,
  };
};
